import PropTypes from 'prop-types';
import React from 'react';
import { Button, Menu, Move } from '@opendate-app/setlist';

const POSITIONS = [
  ['top-left', 'Top left'], ['top-center', 'Top center'], ['top-right', 'Top right'],
  ['center-left', 'Left edge'], ['center-right', 'Right edge'],
  ['bottom-left', 'Bottom left'], ['bottom-center', 'Bottom center'], ['bottom-right', 'Bottom right']
];

const VenueConductorOrbControls = ({ enabled, menuOpen, onMove, onOpenChange, onPointerDown, onClickCapture }) => {
  return (
    <span
      className={`venue-conductor-orb-move-control-anchor${menuOpen ? ' is-menu-open' : ''}`}
      hidden={!enabled}
    >
      <span className="venue-conductor-orb-position-trigger">
        <Menu
          trigger={(
            <Button variant="secondary" size="sm" icon={Move} className="venue-conductor-orb-move-control"
              aria-label="Move Conductor shortcut" onPointerDown={onPointerDown} onClickCapture={onClickCapture} />
          )}
          open={enabled && menuOpen}
          onOpenChange={onOpenChange}
          placement="top-end"
          minWidth={200}
          className="venue-conductor-orb-position-menu"
          aria-label="Move Conductor to"
          items={POSITIONS.map(([id, label]) => ({ key: id, label, onClick: () => onMove(id) }))}
        />
      </span>
    </span>
  );
};

VenueConductorOrbControls.propTypes = {
  enabled: PropTypes.bool.isRequired,
  menuOpen: PropTypes.bool.isRequired,
  onMove: PropTypes.func.isRequired,
  onOpenChange: PropTypes.func.isRequired,
  onPointerDown: PropTypes.func.isRequired,
  onClickCapture: PropTypes.func.isRequired
};

export default VenueConductorOrbControls;
